/* pagina sobre no estilo novo: "continuar lendo" da historia, "ver mais" de cada ano da linha do tempo e os videos
   dos marcos. o conteudo fechado fica no html com hidden="until-found": a busca da pagina (ctrl+f) encontra e abre */
(() => {
  if (window.ntSobreB) return;
  window.ntSobreB = true;

  /* abrir e recolher: o botao recolhendo fica no mesmo lugar da tela, o texto some acima dele */
  const ligarAbre = (bt) => {
    const alvo = document.getElementById(bt.getAttribute('aria-controls'));
    if (!alvo) return;
    const rotulo = bt.querySelector('[data-sb-rotulo]');
    const marcar = (aberto) => {
      bt.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      if (rotulo) rotulo.textContent = aberto ? bt.dataset.fechar : bt.dataset.abrir;
    };
    bt.addEventListener('click', () => {
      if (alvo.hasAttribute('hidden')) {
        alvo.hidden = false;
        marcar(true);
        return;
      }
      const antes = bt.getBoundingClientRect().top;
      alvo.setAttribute('hidden', 'until-found');
      marcar(false);
      const depois = bt.getBoundingClientRect().top;
      if (Math.abs(depois - antes) > 1) window.scrollBy({ top: depois - antes, behavior: 'instant' });
    });
    alvo.addEventListener('beforematch', () => marcar(true));
  };

  /* videos dos marcos: tocam sem som quando o cartao aparece e param quando sai. quem pausou no botao manda;
     com movimento reduzido nada toca sozinho */
  const reduz = window.matchMedia('(prefers-reduced-motion: reduce)');
  const tocar = (v) => {
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };
  const olho = 'IntersectionObserver' in window
    ? new IntersectionObserver((itens) => {
        itens.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.55) {
            if (!reduz.matches && v.dataset.sbParado !== '1') tocar(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.55] })
    : null;

  const ligarVideo = (v) => {
    const bt = v.parentElement.querySelector('[data-sb-play]');
    const estado = () => {
      if (!bt) return;
      bt.setAttribute('aria-pressed', v.paused ? 'false' : 'true');
      v.parentElement.classList.toggle('is-tocando', !v.paused);
    };
    v.addEventListener('play', estado);
    v.addEventListener('pause', estado);
    if (bt) {
      bt.addEventListener('click', () => {
        if (v.paused) {
          v.dataset.sbParado = '0';
          tocar(v);
        } else {
          v.dataset.sbParado = '1';
          v.pause();
        }
      });
    }
    if (olho) olho.observe(v);
  };

  const iniciar = () => {
    document.querySelectorAll('[data-sb-abre]').forEach((bt) => {
      if (bt.dataset.sbLigado) return;
      bt.dataset.sbLigado = '1';
      ligarAbre(bt);
    });
    document.querySelectorAll('[data-sb-video]').forEach((v) => {
      if (v.dataset.sbLigado) return;
      v.dataset.sbLigado = '1';
      ligarVideo(v);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  /* editor de temas: secao recarregada no painel */
  document.addEventListener('shopify:section:load', iniciar);
})();
